/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const createCheckoutResponseCallbackTwoUrlMax = 2048;

export const CreateCheckoutResponse = zod
	.object({
		callback: zod.union([
			zod.null(),
			zod.object({
				method: zod.enum(['async_upload', 'url_upload', 'direct_upload']),
				url: zod
					.string()
					.max(createCheckoutResponseCallbackTwoUrlMax)
					.describe('URL to receive callback with moderated content')
			})
		]),
		checkout_id: zod.string().describe('Unique checkout identifier'),
		expires_at: zod.iso.datetime({ offset: true }).describe('Checkout expiration time'),
		expires_in: zod.number().describe('Expiration time in seconds'),
		signed_url: zod.url().describe('Signed URL for content submission'),
		status: zod.enum(['open', 'closed']),
		token: zod.string().describe('JWT token for content submission')
	})
	.describe('Checkout creation response with signed URL');

export type CreateCheckoutResponse = zod.input<typeof CreateCheckoutResponse>;
export type CreateCheckoutResponseOutput = zod.output<typeof CreateCheckoutResponse>;
